// Tiny synthesized sound effects (no assets needed).
let ctx = null;
let muted = false;
export const setMuted = (m) => { muted = m; };
export const isMuted = () => muted;

function tone(freq, dur, type = 'square', vol = 0.05, slide = 0) {
  if (muted) return;
  try {
    ctx = ctx || new (window.AudioContext || window.webkitAudioContext)();
    const o = ctx.createOscillator();
    const g = ctx.createGain();
    o.type = type;
    o.frequency.setValueAtTime(freq, ctx.currentTime);
    if (slide) o.frequency.exponentialRampToValueAtTime(Math.max(40, freq + slide), ctx.currentTime + dur);
    g.gain.setValueAtTime(vol, ctx.currentTime);
    g.gain.exponentialRampToValueAtTime(0.0001, ctx.currentTime + dur);
    o.connect(g).connect(ctx.destination);
    o.start();
    o.stop(ctx.currentTime + dur);
  } catch (e) { /* audio unavailable */ }
}

function noise(dur, vol = 0.05, hp = 1200) {
  if (muted) return;
  try {
    ctx = ctx || new (window.AudioContext || window.webkitAudioContext)();
    const n = Math.floor(ctx.sampleRate * dur);
    const buf = ctx.createBuffer(1, n, ctx.sampleRate);
    const d = buf.getChannelData(0);
    for (let i = 0; i < n; i++) d[i] = (Math.random() * 2 - 1) * Math.pow(1 - i / n, 3);
    const src = ctx.createBufferSource();
    const f = ctx.createBiquadFilter();
    const g = ctx.createGain();
    src.buffer = buf; f.type = 'highpass'; f.frequency.value = hp; g.gain.value = vol;
    src.connect(f).connect(g).connect(ctx.destination);
    src.start();
  } catch (e) { /* audio unavailable */ }
}

export const sfx = {
  compress: () => { tone(90, 0.16, 'sine', 0.14, -30); noise(0.08, 0.04, 300); },
  spring: () => { tone(220, 0.22, 'sine', 0.1, 520); setTimeout(() => tone(140, 0.12, 'triangle', 0.06, 260), 30); },
  hit: (k) => { noise(0.035 + k * 0.03, 0.03 + k * 0.08, 1800 - k * 900); tone(500 + Math.random() * 500, 0.03, 'square', 0.01 + k * 0.03); },
  land: () => { noise(0.07, 0.09, 500); tone(150, 0.12, 'sine', 0.12); setTimeout(() => tone(880, 0.25, 'triangle', 0.05), 90); },
  pop: () => { tone(180, 0.12, 'sine', 0.12, 200); setTimeout(() => tone(90, 0.1, 'sine', 0.1), 60); },
  rattle: () => { for (let i = 0; i < 6; i++) setTimeout(() => tone(700 + Math.random() * 600, 0.03, 'square', 0.025), i * 70); },
  settle: () => tone(420, 0.08, 'triangle', 0.08),
  step: () => tone(260, 0.05, 'triangle', 0.05),
  capture: () => { tone(160, 0.3, 'sawtooth', 0.08, -110); },
  home: () => { [523, 659, 784].forEach((f, i) => setTimeout(() => tone(f, 0.15, 'triangle', 0.07), i * 110)); },
  combat: () => { [110, 90, 140].forEach((f, i) => setTimeout(() => tone(f, 0.18, 'sawtooth', 0.09), i * 140)); },
  win: () => { [523, 659, 784, 1046].forEach((f, i) => setTimeout(() => tone(f, 0.25, 'triangle', 0.08), i * 150)); },
};
